import { Suspense, React } from 'react'
import { Route, Routes, Outlet } from 'react-router-dom'
import { LoginCallback } from '@okta/okta-react'
import Loader from 'ui/components/Loader'
import PrivateOutlet from 'ui/components/PrivateOutlet'
import Header from 'ui/components/Header/Header'
import Alert from 'ui/components/Alert/Alert'
import { useAppSelector } from 'store'
import Login from 'pages/Login'
import AppRoutes from './AppRoutes'

export function LoadingBox() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Loader isLoading />
    </div>
  )
}

function PrivateLayout() {
  const toastNotifications = useAppSelector((state) => state.common.toastNotifications)
  return (
    <div style={{ minWidth: '1440px' }}>
      <Header />
      <div style={{ padding: 'var(--spacing-16)' }}>
        <Outlet />
      </div>
      {toastNotifications.show && <Alert data={toastNotifications} />}
    </div>
  )
}

function AllRoutes() {
  return (
    <Suspense fallback={<LoadingBox />}>
      <Routes>
        <Route path="/login/callback" element={<LoginCallback loadingElement={<Loader />} />} />
        <Route path="/login" element={<Login />} />
        {/* Protected area */}
        <Route element={<PrivateOutlet />}>
          <Route element={<PrivateLayout />}>
            {AppRoutes?.map((route) =>
              route.path ? (
                <Route key={route.id} path={route.path} element={<route.element />} />
              ) : (
                <Route key={route.id} index element={<route.element />} />
              )
            )}
          </Route>
        </Route>
      </Routes>
    </Suspense>
  )
}

export default AllRoutes
